/**
 * bookingsRefreshBus — a tiny pub/sub so a booking created from ANYWHERE
 * (the global "New booking" launcher — palette, "c then b", or the on-page
 * CTA/FAB, which now all route through the same launcher) can refresh the
 * Bookings list + KPI strip when `BookingPage` happens to be mounted
 * (BON-142). The bookings list has no react-query cache to invalidate — it's
 * local `useState` in `useBookingsListState` — so this is the shared-signal
 * alternative called out in the task brief. A no-op when nobody's listening
 * (e.g. the booking was created from a different page).
 */
export interface BookingCreatedEvent {
  kind: 'comp' | 'reservation';
}

type Listener = (event: BookingCreatedEvent) => void;

const listeners = new Set<Listener>();

/** Subscribe to booking-created notifications. Returns an unsubscribe fn —
 *  call it from a `useEffect` cleanup. */
export function subscribeToBookingsRefresh(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Notify all subscribers that a booking was created. */
export function notifyBookingCreated(event: BookingCreatedEvent): void {
  listeners.forEach((listener) => listener(event));
}
